/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compare_TitleInputs */

const en_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere`)
};

const de_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoer auf, ueberall den gleichen Lebenslauf zu schicken`)
};

const fr_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrête d'envoyer le même CV partout`)
};

const es_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja de enviar el mismo currículum a todas partes`)
};

const it_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smettila di mandare lo stesso curriculum ovunque`)
};

const nl_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop met overal hetzelfde CV versturen`)
};

const pl_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przestań wysyłać wszędzie to samo CV`)
};

const fi_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lopeta saman ansioluettelon lähettäminen kaikkialle`)
};

const da_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop med at sende det samme CV overalt`)
};

const sv_landing_compare_title = /** @type {(inputs: Landing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluta skicka samma CV överallt`)
};

/**
* | output |
* | --- |
* | "Stop sending the same resume everywhere" |
*
* @param {Landing_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compare_title = /** @type {((inputs?: Landing_Compare_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compare_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compare_title(inputs)
	if (locale === "fr") return fr_landing_compare_title(inputs)
	if (locale === "es") return es_landing_compare_title(inputs)
	if (locale === "it") return it_landing_compare_title(inputs)
	if (locale === "nl") return nl_landing_compare_title(inputs)
	if (locale === "pl") return pl_landing_compare_title(inputs)
	if (locale === "fi") return fi_landing_compare_title(inputs)
	if (locale === "da") return da_landing_compare_title(inputs)
	if (locale === "sv") return sv_landing_compare_title(inputs)
	return en_landing_compare_title(inputs)
});